import httpClient from "./httpClient";

const USER_LOGIN = "/users/login";
const USER_DETAILS = "/users/me";
const INSTALATIONS_DROPDOWN = "/dropdowns/active-entities";
const USER_REGISTER = "/users/register";

function loginUser(userObj) {
    return httpClient.post(USER_LOGIN, userObj, {
        headers: { Authorization: "" },
    });
} 

function fetchUserDetails() {
    return httpClient.get(USER_DETAILS);
}

function getInstalationsDropdown(idInstance) {
    return httpClient.get(`${INSTALATIONS_DROPDOWN}?idInstance=${idInstance}`);
}

function registerNewUser(payload) {
    return httpClient.post(USER_REGISTER, payload);
}


export { loginUser, fetchUserDetails, getInstalationsDropdown, registerNewUser };
